// Bundelkeuze (snippets/hi-bundle.liquid): vult id, quantity en de Section Store-eigenschap in het productformulier,
// zodat de bestaande add-to-cart van Horizon het pack toevoegt. De korting rekent Section Store in de winkelwagen.
class HiBundle extends HTMLElement {
  connectedCallback() {
    this.form = document.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"] form`);
    this.sizes = this.querySelector('.hi-bundle__sizes');
    if (!this.form || !this.sizes) return;

    this.addEventListener('change', () => this.update());
    this.update();
  }

  field(name) {
    let input = this.form.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = Object.assign(document.createElement('input'), { type: 'hidden', name });
      this.form.append(input);
    }
    return input;
  }

  update() {
    const pack = this.querySelector('.hi-bundle__option > .hi-bundle__radio:checked');
    const size = this.sizes.querySelector('.hi-bundle__radio:checked');
    if (!pack || !size) return;

    pack.parentElement.append(this.sizes);
    this.field('id').value = size.value;
    this.field('quantity').value = pack.value;
    this.field('properties[__section_store_bundle]').value = JSON.stringify({
      bundle_id: this.dataset.bundleId,
      bundle_option_id: pack.dataset.optionId,
    });
  }
}

if (!customElements.get('hi-bundle')) customElements.define('hi-bundle', HiBundle);
